// Central place to declare query-key factories per feature.
//
// Colocating keys here keeps invalidation predictable and avoids typos from
// inline string arrays scattered across the app. Keys are hierarchical: a broad
// prefix (e.g. `blog.all`) invalidates everything nested under it, while a
// factory (e.g. `blog.detail(slug)`) targets one cache entry.

export const queryKeys = {
  blog: {
    all: ["blog"] as const,
    list: (tag: string) => ["blog", "list", tag] as const,
    latest: (limit: number) => ["blog", "latest", limit] as const,
    detail: (slug: string) => ["blog", "detail", slug] as const,
  },
  careers: {
    all: ["careers"] as const,
    list: ["careers", "list"] as const,
    detail: (slug: string) => ["careers", "detail", slug] as const,
  },
} as const;
